import { useState } from "react"
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import ToastNotification from '../../components/ToastNotification';


const EditBranch = () => {
    const navigate = useNavigate()

    const { state } = useLocation();
    const branch = state?.branch;


    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });

    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };

    

    const [forms, setForm] = useState({
        id: branch?.id || "",
        name: branch?.name || "",
        email: branch?.email || "",
        phone: branch?.phone || "",
        address: branch?.address || "",
        city: branch?.city || "",
        state: branch?.state || "",
        fax: branch?.fax || "",
        pincode: branch?.pincode || "",
        code: branch?.code || "",
        remark: branch?.remark || "",
        lbt_no: branch?.lbt_no || "",
        company: branch?.company || "",
        head: branch?.header_img || null,
        footer: branch?.footer_img || null
    });


    const [files, setFiles] = useState({
        head: null,
        footer: null
    });


    const handleFileChange = (e) => {
        setFiles(prev => ({ ...prev, [e.target.name]: e.target.files[0] }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...forms, [name]: value });
    };





    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        Object.keys(forms).forEach((key) => {
            data.append(key, forms[key]);
        });

        Object.keys(files).forEach((key) => {
            if (files[key]) data.append(key, files[key]);
        });

        try {
            await axios.put(
                `https://api.skyguard.group/api/update-branch/${forms.id}`, // ✅ use branch ID
                data,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            showToast('Branch updated successfully', 'success');
            setTimeout(() => {
                navigate('/admin/branches');

            }, 3000);

        } catch (err) {
            console.error(err);
            showToast('Failed to update branch', 'danger');
        }
    };



    return (
        <>
            <div className='main-section'>

                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />

                    <button className='btn btn-primary' onClick={() => navigate('/admin/branches')}> Back</button>

                    <h3 className='my-3 fw-bold fs-5 golos'>Edit Branch Detail</h3>



                    <div className='card p-3 mb-3'>
                        <form onSubmit={handleSubmit} >

                            <h5 className="mt-3 ">Basic Info</h5>

                            <hr />

                            <div className='row g-3'>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={forms.name} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="email" placeholder="Email" value={forms.email} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="number" className="form-control" name="phone" placeholder="Phone No" value={forms.phone} onChange={handleInputChange} />
                                </div>

                                <div className="col-md-4">
                                    <input type="test" className="form-control" name="code" placeholder="Branch Code " value={forms.code} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="address" placeholder="Address" value={forms.address} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="city" placeholder="City" value={forms.city} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="state" placeholder="State" value={forms.state} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="pincode" placeholder="Pincode" value={forms.pincode} onChange={handleInputChange} />
                                </div>

                                <h5 className="mt-4">Other Details</h5>
                                <hr />
                                <div className="row g-3">

                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="remark" placeholder="Remark" value={forms.remark} onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="fax" placeholder="Fax" value={forms.fax} onChange={handleInputChange} />
                                    </div>



                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="lbt_no" placeholder="LBT No." value={forms.lbt_no} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="company" placeholder="Compnay Name" value={forms.company} onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label" >Letter Head</label>

                                        <input type="file" className="form-control   " name="head_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                      
                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label" > Letter Head Footer</label>

                                        <input type="file" className="form-control" name="footer_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>


                                </div>

                            
                                <div className="col-md-12 text-end">
                                    <button className='btn btn-primary' type='submit' >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>



                </div>
            </div>
        </>
    )
}
export default EditBranch